import { ReactNode } from 'react'
import HelpOutline from '@mui/icons-material/HelpOutline'
import { Card, Stack, Tooltip, Typography } from '@mui/material'

export type ChartCardProps = {
  children: ReactNode
  heading: ReactNode
  headingTooltip?: ReactNode
  controls?: ReactNode
}

export default function ChartCard({
  children,
  heading,
  headingTooltip,
  controls,
}: ChartCardProps) {
  return (
    <Card elevation={2} sx={{ p: 2, overflow: 'visible', height: '100%' }}>
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body1">{heading}</Typography>
            {headingTooltip && (
              <Tooltip title={headingTooltip}>
                <HelpOutline
                  fontSize="small"
                  sx={{ color: 'text.secondary' }}
                />
              </Tooltip>
            )}
          </Stack>
          {controls}
        </Stack>
        {children}
      </Stack>
    </Card>
  )
}
